// Polyfills useds:
import "core-js/stable";
import "whatwg-fetch";

import * as Sentry from "@sentry/react";

function initializeSentry() {
  if (process.env.NODE_ENV !== "production") {
    return;
  }
  const userConsentForSessionReplay =
    sessionStorage.getItem("sessionReplayConsent") === "true";

  let integrations = [];
  if (userConsentForSessionReplay) {
    integrations = [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [window.location.origin],
      }),
    ];
  }

  Sentry.init({
    dsn: "https://c086b4a095d9421ebeec620a42f7e828@o201630.ingest.sentry.io/5406232",
    integrations: integrations,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });

  if (userConsentForSessionReplay) {
    const replay = Sentry.getReplay();
    replay.start();
  }
}

initializeSentry();
